<div *ngIf="viewData.length">
    <table class="mt-table mt-table-striped" aria-label="table-checklist">
        <thead>
            <tr>
                <!-- Date -->
                <th scope="col" sortable="createAt" (sort)="onSort($event)">
                    <span class="header-title">{{ "date-hour" | lang }}</span>
                    <app-table-sort-icon
                        class="float-left"
                        [property]="'createAt'"
                        [sort$]="table?.sort$"
                    ></app-table-sort-icon>
                </th>
                <!-- Shift -->
                <th scope="col" sortable="shiftName" (sort)="onSort($event)">
                    <span class="header-title">{{ "shiftname" | lang }}</span>
                    <app-table-sort-icon
                        class="float-left"
                        [property]="'shiftName'"
                        [sort$]="table?.sort$"
                    ></app-table-sort-icon>
                </th>
                <!-- Machine -->
                <th scope="col" sortable="machineName" (sort)="onSort($event)">
                    <span class="header-title">{{ "machinename" | lang }}</span>
                    <app-table-sort-icon
                        class="float-left"
                        [property]="'machineName'"
                        [sort$]="table?.sort$"
                    ></app-table-sort-icon>
                </th>
                <!-- operator -->
                <th scope="col" sortable="operatorName" (sort)="onSort($event)">
                    <span class="header-title">{{ "operator" | lang }}</span>
                    <app-table-sort-icon
                        class="float-left"
                        [property]="'operatorName'"
                        [sort$]="table?.sort$"
                    ></app-table-sort-icon>
                </th>
                <!-- Detail -->
                <th scope="col">
                    <span class="header-title">{{ "message" | lang }}</span>
                </th>
                <!-- Download -->
                <th scope="col">
                    <span class="header-title">{{ "download" | lang }}</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let d of viewData">
                <td>{{ d.createAt | dateTimePresentation }}</td>
                <td>{{ d.shiftName }}</td>
                <td>{{ d.machineName }}</td>
                <td>{{ d.operatorName }}</td>
                <td>
                    <span (click)="openModal(d)">{{
                        "see-detail" | lang
                    }}</span>
                </td>
                <td>
                    <app-button-icon
                        [image]="'download'"
                        [iconType]="'icon'"
                        [disabled]="d.disabledExcelBtn"
                        [spinner]="d.spinner"
                        (clickHandler)="downloadExcel(d)"
                    ></app-button-icon>
                </td>
            </tr>
        </tbody>
    </table>
    <app-mt-table-pagination
        [pageSize]="pageSize"
        [collectionSize]="collectionSize"
        (changePageSize)="onChangePageSize($event)"
        (changePage)="onChangePage($event)"
    >
    </app-mt-table-pagination>
</div>
